import { useContext, useEffect, useState } from "react";
import HeaderProfile from "./HeaderProfile";
import { TransparantIcon } from "./Button/IconButton";
import { useNavigate } from "react-router-dom";
import { Menu } from "./MenuBar/Menu";
import {truncateText} from "../common/functions";
import AuthContext from "../contexts/AuthContext";
import addEvent from "../assets/icons/addEvent.svg";
import { Icon } from '@iconify/react';


const Header = ({
  backButton,
  children,
  stopScanner,
  menuBar,
  selectedMenu,
  eventId,
  sponsorCode,
  eventName
}) => {
  const context = useContext(AuthContext);
	const [showChromeWarning, setShowChromeWarning] = useState(true);

  const navigate = useNavigate();
  let removeHome = context?.eventDetails?.removeHome?true:false;

  const backHandler = () => {
    navigate(-1);
    if (stopScanner) {
      stopScanner();
    }
  };

  const onClickHome = () => {
    navigate({ pathname: "/Events" });
  };
  const onClickScan = () => {
    navigate({
      pathname: `/Events/${eventId}/scanDetails`,
      search: `?sponsor=${sponsorCode}`,
    });
  };
  const onClickLeads = () => {
    navigate({
      pathname: `/Events/${eventId}/view-leads`,
      search: `?sponsor=${sponsorCode}`,
    });
  };

  const onClickAddEvent = () =>{
    navigate({ pathname: "/addEventModal" });
  };

  let menuItems = [
    {
      menuName: "Scan",
      menuSelectedIcon: "/icons/scan-orange.svg",
      menuIcon: "/icons/scan-white.svg",
      onClickMenuItem: onClickScan,
    },
    {
      menuName: "Leads",
      menuSelectedIcon: "/icons/lead-orange.svg",
      menuIcon: "/icons/lead-white.svg",
      onClickMenuItem: onClickLeads,
    },
  ];

  menuItems= removeHome ? [{menuName:"Add event", 
  menuSelectedIcon: addEvent, 
  menuIcon: addEvent,
  onClickMenuItem: onClickAddEvent}, ...menuItems] : 
  [{menuName:"Home", 
  menuSelectedIcon: "/icons/home-orange.svg", 
  menuIcon: "/icons/home-white.svg",
  onClickMenuItem: onClickHome}, ...menuItems]


  	const isUsingGoogleChrome = () => {
		if (typeof navigator === "undefined") return false;

		const ua = navigator.userAgent || "";
		const vendor = navigator.vendor || "";

		const isIOS = /iPad|iPhone|iPod/.test(ua);
		const isCriOS = ua.includes("CriOS"); // Chrome on iOS
		const isChromeDesktop = ua.includes("Chrome") && vendor === "Google Inc.";
		const isNotEdge = !ua.includes("Edg");
		const isNotOpera = !ua.includes("OPR");
		const isNotBrave = !navigator.brave;

		if (isIOS) {
			return isCriOS;
		}

		return isChromeDesktop && isNotEdge && isNotOpera && isNotBrave;
	};

	const isChrome = isUsingGoogleChrome();

	useEffect(() => {
		if (showChromeWarning && !isChrome) {
			document.body.classList.add("chrome-warning-visible");
		} else {
			document.body.classList.remove("chrome-warning-visible");
		}
	}, [showChromeWarning]);

  return (
    <div>
        {!isChrome && showChromeWarning && (
				<div className="pb-4">
					<div className="position-absolute  top-0 w-100">
						<div className="chrome-message position-relative chrome-screen">
							<div className="chrome-screen ">
								<div className="m-auto">
									<Icon
										icon="devicon:chrome"
										width={24}
										height={24}
										className="me-3 chrome-icon"
									/>
								</div>
								<span>
									{" "}
									Please use Chrome for the best experience with the Sponsor App.
								</span>
								<Icon
									icon="radix-icons:cross-2"
									width={24}
									height={24}
									className=" close-icon"
									onClick={() => setShowChromeWarning(false)}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
    
    <div className="d-flex justify-content-between me-3 ms-2 back-handler">
    
      <div className="d-flex">
        <TransparantIcon
          onClick={() => backHandler()}
          className={backButton ? "mb-1 px-2 d-flex align-items-start mt-1" : "d-none"}
        >
          <img src="/icons/backarrow.svg" alt="back-button"></img>
        </TransparantIcon>
        <div>
          <div className="header-text ps-1">{children}</div>
          {
            eventName &&
            (
              <div className="d-flex ps-sm-1">
                <span style={{color:"#572148"}}>(</span>
                <div className="eventName-header">{truncateText(eventName, 30)}</div>
                <span style={{color:"#572148"}}>)</span>
              </div>
            )
          }
        </div>
      </div>
      <div className="d-flex">
        {menuBar && (
          <Menu menuItems={menuItems} selectedKey={selectedMenu}></Menu>
        )}
        <HeaderProfile className="mt-1"></HeaderProfile>
      </div>

      <style>
        {`
            .header-text{
                color: var(--secondaryColor);
                font-weight: 600;
                font-size: 24px;
                font-family: var(--font-family);
            }

            			.chrome-message {
				width: 100%;
				padding: 10px 16px;
				background-color: #F6F4EF;
				border: 1px solid #ccc;
				position: fixed;
				top: 0;
				left: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
				}

				.chrome-message span {
					flex-grow: 1;
					font-size: 0.9rem;
					color: #333;
					text-align: left;
          
				}

				.chrome-screen{
					display: flex;
					justify-content: center;
					align-items: center;
				}


				body.chrome-warning-visible .top-container{
					padding-top: 50px; 
				}
				
			
				body.chrome-warning-visible .back-handler {
					padding-top: 20px;
				}
				.close-icon {
					cursor: pointer;
					position: absolute;
					right: 16px;
				}
				.chrome-icon{
					margin-bottom: 2px
				}
          @media (max-width: 600px) {
          .chrome-message span {
            margin-right: 32px;
          }
        }
            `}
      </style>
    </div>
    </div>
  );
};

export default Header;
